import React from 'react';

const ChatSidebar = ({
  id,
  threads,
  isLoading,
  error,
  hasMore,
  onLoadMore,
  activeChatId,
  onOpenThread,
}) => {
  return (
    <aside
      id={id}
      className="w-72 border-r border-gray-700 bg-gray-900/80 backdrop-blur-sm flex flex-col"
    >
      <div className="px-4 py-3 border-b border-gray-700">
        <h2 className="text-sm font-semibold text-gray-200">History</h2>
      </div>
      <div className="flex-1 overflow-y-auto px-2 py-2 space-y-2">
        {threads.length === 0 && !isLoading && !error && (
          <p className="px-2 py-3 text-xs text-gray-400">No chats yet.</p>
        )}
        {threads.map((thread) => (
          <button
            key={thread.thread_id}
            type="button"
            onClick={() => onOpenThread(thread.thread_id)}
            className={
              'w-full text-left rounded-xl px-3 py-2 transition-colors border ' +
              (thread.thread_id === activeChatId
                ? 'bg-blue-600/20 border-blue-400 text-white'
                : 'bg-gray-800/60 border-gray-700 text-gray-200 hover:bg-gray-700/80')
            }
          >
            <p className="text-sm font-medium truncate">{thread.title || 'Untitled chat'}</p>
            <p className="text-xs text-gray-400 truncate mt-1">
              {thread.last_message_preview || 'No messages yet'}
            </p>
            <p className="text-[11px] text-gray-500 mt-1">{thread.message_count} messages</p>
          </button>
        ))}
        {error && <p className="px-2 py-2 text-xs text-red-300">{error}</p>}
      </div>
      {hasMore && (
        <div className="px-3 py-3 border-t border-gray-700">
          <button
            type="button"
            onClick={onLoadMore}
            disabled={isLoading}
            className={
              'w-full rounded-lg px-3 py-2 text-xs font-medium transition-colors ' +
              (isLoading
                ? 'bg-gray-700 text-gray-400 cursor-not-allowed'
                : 'bg-gray-700 text-gray-200 hover:bg-gray-600')
            }
          >
            {isLoading ? 'Loading...' : 'Load more'}
          </button>
        </div>
      )}
    </aside>
  );
};

export default ChatSidebar;
